import LABELESPECIAL from '../../business-const/Label/LabelEspecial'

import {
    descricaoMenu,
} from '../../business-components/String/String'

import {
    sortAsc
} from '../../business-components/Sort/Sort'

import {
    semAcento
} from '../../business-components/String/String'



export const pesquisaList = (list, id, idName) => {

    let listEncontrada = {}

    if (!idName) {

        idName = 'id'
    }

    list?.forEach( (linhaList, index) => {

        if (linhaList[idName] === id) {
            
            listEncontrada = linhaList
        }
    })

    return listEncontrada
}



export const pesquisaDescricaoList = (list, id) => {
    const descricao = pesquisaList(list, id).descricao

    return descricao ? descricao : ""
}



export const pesquisaIndexList = (list, id) => {

    let indexEncontrado = null

    list?.forEach( (linhaList, index) => {

        if (linhaList.id === id) {
            
            indexEncontrado = index
        }
    })

    return indexEncontrado
}



export const pesquisaIdList = (list, descricao) => {
    
    let listEncontrada = {}

    list?.forEach( (linhaList, index) => {

        if (!listEncontrada.id) {

            if (semAcento(linhaList.descricao.toUpperCase()) === semAcento(descricao.toUpperCase())) {
            
                listEncontrada = linhaList
            }
        }
    })

    return listEncontrada.id
}



export const pesquisaChaveList = (list, chave) => {
    
    let listEncontrada = {}

    list?.forEach( (linhaList, index) => {

        if (!listEncontrada.id) {

            linhaList.chaves?.forEach( (linhaChaves, indexChaves) => {

                if (linhaChaves.id === chave) {
                
                    listEncontrada = linhaList
                }
            })
        }
    })

    return listEncontrada
}



export const pesquisaAutoCompleteList = (list, descricao) => {
    
    let listEncontrada = null

    list?.forEach( (linhaList, index) => {

        if (!listEncontrada) {
        
            if (semAcento(linhaList.toUpperCase()) === semAcento(descricao.toUpperCase())) {
                
                listEncontrada = linhaList
            }
        }
    })

    return listEncontrada
}



export const indexMenu = (menu, descricao) => {

    let indexMenuAux = null

    menu?.forEach( (linhaMenu, index) => {

        if (indexMenuAux === null && descricaoMenu(linhaMenu) === descricao) {
            
            indexMenuAux = index
        }
    })

    return indexMenuAux
}



export const descricoesValidasList = (list) => {

    let listAux = []

    listAux.push(...list)

    listAux = sortAsc(listAux)


    
    let descricoesValidas = ''

    listAux?.forEach( (linhaListAux, index) => {

        if (descricoesValidas) {

            descricoesValidas += ', '
        }
            
        descricoesValidas += linhaListAux.id + LABELESPECIAL.ou + linhaListAux.descricao
    })

    return descricoesValidas
}



const posicaoColumnsExibe = ( columnsExibe, id, ordem ) => {

    if (columnsExibe) {

        columnsExibe?.forEach( ( linhaColumnsExibe, index) => {

            if ( linhaColumnsExibe.id === id ) {

                ordem = index
            }
        })
    }

    return ordem
}



export const incluiCampoList = ({ camposList, columnsExibe, grafico, filtroList, name, label, filtro, filtroGrafico, type, tamMax, numMin, numMax,
    list, columnsDefault, options, permiteAgrupar, permiteGerarPDFQuebra, ordem }) => {

    if (
            (!columnsExibe || pesquisaList(columnsExibe, name).id) &&
            (!grafico || filtroGrafico === 'S' || pesquisaList(filtroList, name).id)
    ) {

        camposList.push(
            {
                id: name,
                name: name,
                descricao: label,
                label: label,
                type: type,
                filtro: filtro,
                tamMax: tamMax,
                numMin: numMin,
                numMax: numMax,
                list: list,
                columnsDefault: columnsDefault,
                options: options,
                permiteAgrupar: permiteAgrupar,
                permiteGerarPDFQuebra: permiteGerarPDFQuebra,
                ordem: posicaoColumnsExibe(columnsExibe, name, ordem),
            },
        )
    }
}



const columnsExibeNaoExibe = (linhaList) => {

    return {
        id: linhaList.name,
        content: linhaList.label,
        permiteAgrupar: linhaList.permiteAgrupar,
        permiteGerarPDFQuebra: linhaList.permiteGerarPDFQuebra,
    }
}

export const calculaColumnsInicial = ( list, dashboard, filtroLists, variaveisGlobais, camposList ) => {

    camposList(
        list,
            (
                dashboard.columnsExibe.length === 0 && dashboard.columnsNaoExibe.length === 0
                    ? 
                        null
                    :
                        dashboard.columnsExibe
            ), false, dashboard.filtroList, filtroLists, variaveisGlobais)?.forEach( (linhaList, indList) => {

        if (
                linhaList.columnsDefault === 'S'
        ) {

            dashboard.columnsExibe.push(columnsExibeNaoExibe(linhaList))

        } else {
                
            dashboard.columnsNaoExibe.push(columnsExibeNaoExibe(linhaList))
        }
    })
}

export const ajustaColumnsInicial = ( dashboard, camposList, variaveisGlobais ) => {

    const camposListAux = camposList([], null, false, [], [], variaveisGlobais)

    camposListAux?.forEach( (linhaList, indList) => {

        if (!pesquisaList(dashboard.columnsExibe, linhaList.id).id && !pesquisaList(dashboard.columnsNaoExibe, linhaList.id).id) {

            dashboard.columnsNaoExibe.push(columnsExibeNaoExibe(linhaList))
        }
    })



    let index = dashboard.columnsExibe.length - 1

    while (index >= 0) {

        if (!pesquisaList(camposListAux, dashboard.columnsExibe[index].id).id) {

            dashboard.columnsExibe.splice(index, 1)
        }

        index -= 1
    }



    index = dashboard.columnsNaoExibe.length - 1

    while (index >= 0) {

        if (!pesquisaList(camposListAux, dashboard.columnsNaoExibe[index].id).id) {

            dashboard.columnsNaoExibe.splice(index, 1)
        }

        index -= 1
    }
}